
































// @ is an alias to /src
import Vue from 'vue';

export default Vue.extend({
  name: 'motionSearchItem',
  props: {
    motion: {},
  },
  data() {
    return {
      categoryList: '',
    };
  },
  watch: {
  },
  methods: {
    isLastCategory(catNumInList) {
      return catNumInList === this.motion.categories.length - 1;
    },
    isLastTag(tagNumInList) {
      return tagNumInList === this.motion.tags.length - 1;
    },
  },
  mounted() {
  },
});
